
define('text!modules/creatives/concept/templates/bin_title.html',[],function () { return '<div class="header-c title creative-list-title">\n\t<span class="label" data-bind="bin_label">Assigned Creatives</span> <span class="assign-count">(0)</span>\n</div>';});

